import {Component, OnInit} from '@angular/core';
import {ChatService} from 'app/services/chat.service';

@Component({
  selector: 'app-chat-fixed-input',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
})
export class ChatFixedInputComponent implements OnInit {
  constructor(
    public chatService: ChatService
  ) {
  }

  ngOnInit() {
  }

}
